import type { ContentSectionConfig } from "../../@types/portalAluno";

export const CONTENT_SECTIONS: ContentSectionConfig[] = [
  {
    apiType: "DESTAQUES",
    description: "Conteúdos selecionados e novidades em evidência para você.",
    homeKey: "destaques",
    kind: "destaques",
    paginated: false,
    route: "/app/conteudo/destaques",
    title: "Destaques",
    topicType: "destaque",
    topicContentsPath: "mobile/destaque/feedback",
  },
  {
    apiType: "SEGURANCAS",
    description: "Campanhas e orientações para um ambiente de trabalho seguro.",
    homeKey: "segurancaNoTrabalhos",
    kind: "seguranca-do-trabalho",
    paginated: true,
    route: "/app/conteudo/seguranca-do-trabalho",
    title: "Segurança do trabalho",
    topicType: "seguranca",
    topicContentsPath: "mobile/segurancaNoTrabalho/feedback",
  },
  {
    apiType: "T1",
    description: "Treinamentos rápidos e objetivos para consultar no dia a dia.",
    homeKey: "t1",
    kind: "treinamentos-de-1-ponto",
    paginated: true,
    route: "/app/conteudo/treinamentos-de-1-ponto",
    title: "Treinamentos de 1 ponto",
    tagFiltered: true,
    topicType: "t1",
    topicContentsPath: "mobile/t1/feedback",
  },
  {
    apiType: "COMUNICADOS",
    description: "Comunicados e informações importantes para você.",
    homeKey: "comunicados",
    kind: "comunicados",
    paginated: true,
    route: "/app/conteudo/comunicados",
    title: "Comunicados",
    topicType: "comunicado",
    topicContentsPath: "mobile/comunicado/feedback",
  },
  {
    apiType: "CURSOS",
    description: "Cursos disponíveis para ampliar seus conhecimentos.",
    homeKey: "cursos",
    kind: "cursos",
    paginated: true,
    route: "/app/conteudo/cursos",
    title: "Cursos",
    topicType: "curso",
    topicContentsPath: "mobile/curso/feedback",
  },
  {
    apiType: "TRILHAS",
    description: "Jornadas de aprendizagem organizadas por objetivo.",
    homeKey: "trilhas",
    kind: "trilhas",
    paginated: true,
    route: "/app/conteudo/trilhas",
    title: "Trilhas",
    topicType: "trilha",
    topicContentsPath: "mobile/trilha/feedback",
  },
];

export const getContentSection = (kind?: string) =>
  CONTENT_SECTIONS.find((section) => section.kind === kind);
